import styled, { css } from 'styled-components';

import { tokens } from '../../../../design/tokens';

interface CourseContainerProps {
  type: string;
  /**
   * Silhueta da fileira nova: largura herdada do <li> (--card-w) e a mesma
   * proporção do CourseCardV3. Sem esta prop o componente mantém a geometria
   * fixa antiga, porque CoursesContainerAllItems (/categorycourses) ainda
   * depende dela e está fora do escopo desta série.
   */
  $fluid?: boolean;
}

const fluidCard = css`
  width: 100%;
  margin-right: 0;

  .bg-skeleton {
    /* Mesma proporção do CourseCardV3 em toda largura — a silhueta do
       esqueleto tem de prever o conteúdo que vai chegar (regra do DESIGN.md). */
    --ratio-w: 2;
    --ratio-h: 1;

    width: 100%;
    height: auto;
    min-height: 0;
    border: 0;
    box-shadow: ${tokens.shadow.imageSeat};
    border-radius: ${tokens.radius.sm} ${tokens.radius.sm} 0 0;

    &::before {
      content: '';
      display: block;
      padding-top: calc(100% * var(--ratio-h) / var(--ratio-w));
    }

    @supports (aspect-ratio: 16 / 9) {
      aspect-ratio: var(--ratio-w) / var(--ratio-h);

      &::before {
        display: none;
      }
    }
  }

  /* A faixa de metadados do card real, em silhueta. */
  > span {
    display: block;
    padding: 10px 10px 15px;
    border-radius: 0 0 ${tokens.radius.sm} ${tokens.radius.sm};
    background: ${tokens.color.cardCharcoal};
  }

  .progress-bar-wrapper-skeleton {
    width: 70%;
    height: 12px;
    margin-top: 0;
    border-radius: ${tokens.radius.xs};
  }

  .progress-bar-skeleton {
    display: none;
  }
`;

export const Container = styled.div<CourseContainerProps>`
  display: flex;
  flex-direction: column;
  margin-right: 36px;
  border-radius: 4px;

  transition: width 0.4s, height 0.4s;

  ${(props) =>
    props.type === 'horizontal' &&
    css`
      width: 240px;
      height: 160px;
    `}

  ${(props) =>
    props.type === 'vertical' &&
    css`
      width: 140px;
      height: 180px;
    `}

  ${(props) =>
    props.type === 'category' &&
    css`
      width: 160px;
      height: 200px;
    `}

  .bg-skeleton {
    width: 240px;
    height: 160px;

    transition: width 0.4s, height 0.4s;

    ${(props) =>
      props.type === 'horizontal' &&
      css`
        width: 240px;
        height: 160px;
      `}

    ${(props) =>
      props.type === 'vertical' &&
      css`
        width: 140px;
        height: 180px;
      `}

    ${(props) =>
      props.type === 'category' &&
      css`
        width: 160px;
        height: 200px;
      `}

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);

    border: solid 0.8px rgba(117, 117, 117, 0.5);
    border-radius: 4px;

    @media (max-width: 980px) {
      min-height: 220px;
      height: 100%;
      width: 150px;
    }
  }

  @media (max-width: 980px) {
    min-height: 150px;
    width: 150px;
  }

  .progress-bar-wrapper-skeleton {
    width: 100%;
    height: 8px;

    margin-top: 14px;

    border-radius: 12px;

    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .progress-bar-skeleton {
    width: 100%;
    height: 100%;

    border-radius: 12px;

    background: rgba(83, 90, 109, 0.4);
  }

  /* Depois das regras legadas, para vencer sem !important. */
  ${(props) => props.$fluid && fluidCard}
`;
